module.exports = __webpack_public_path__ + "img/mobile_EN_US.d0c4b686.png";